import type { IDataBasic } from './common';

export interface HighlightParams {
  cover_image_url: string;
  video_url: string;
  highlight_function_list: {
    name: string;
    description: string[];
  }[];
}

export interface IGetIndustryInfo {
  id: string;
  title: string; // 标题
  subtitle: string; // 副标题
  guiding_text: string; // 引导文案
  background_image_url: string; // 背景图url
  seo_title: string; // 搜索关键字 seo 用的 title
  seo_keywords: string; // 搜索关键字 seo 用的 keywords
  seo_description: string; // 搜索关键字 seo 用的 description
  update_time: number; // 更新时间
  // background_image_url: string // banner
}

export interface IGetCaseItem {
  id: string;
  customer_name: string; // 客户名称
  title: string; // 标题
  is_new: boolean;
  description: string; // 描述
  cover_image_path: string; // 封面图链接
  cover_image_url: string; // 封面图url
  logo_image_path: string; // 客户logo图链接
  logo_image_url: string; // 客户logo图url
  online_status: number; // 上架状态状态: 1：下架，0：上架
  editor_id: number; // 最近修改人user_id
  editor_name: number; // 最近修改人名称
  rank: number; // 排序，数字越小，排序越靠前
  is_delete: number; // 删除状态
  title_card_title: string; // 标题卡片主标题
  title_card_subtitle: string; // 标题卡片副标题
  title_video_path: string; // 标题卡片首屏视频链接
  title_video_url: string; // 标题卡片首屏视频url
  title_logo_image_path: string; // 标题卡客户logo图链接
  title_logo_image_url: string; // 标题卡客户logo图url
  seo_title: string; // 搜索关键字 seo 用的 title
  seo_keywords: string; // 搜索关键字 seo 用的 keywords
  seo_description: string; // 搜索关键字 seo 用的 description
  customer_feedback_text: string; // 客户心声卡片文案
  case_describe: string; // 客户案例描述
  tag_list?: { id: number; name: string }[];
  path_url: string; // 文章访问路径
  tag_ids_admin?: any;
  main_title: string; // 文章主标题
  sub_title: string; // 文章副标题
}

export interface IGetCaseInfo {
  id: string;
  title: string; // 标题
  background_image_url: string; // 背景图url
  subtitle: string; // 副标题
  guiding_text: string; // 引导文案
  seo_title: string; // 搜索关键字 seo 用的 title
  seo_keywords: string; // 搜索关键字 seo 用的 keywords
  seo_description: string; // 搜索关键字 seo 用的 description
  update_time: number; // 更新时间
  type: number; // 类型 0-优秀作品页面
  // background_image_url: string // banner
}

export interface IGetCaseList {
  count: number;
  results: IGetCaseItem[];
}

export interface IProductHighlight extends IDataBasic {
  product_highlights: string;
  title: string;
  description: string;
  upload_path_prefix: string;
  click_jump_to: string;
  card_base_image_path: string;
  card_base_image_url: string;
  card_icon_image_path: string;
  card_icon_image_url: string;
  video_cover_path: string;
  video_cover_url: string;
  card_title: string;
  card_subtitle: string;
  video_path: string;
  video_url: string;
  online_status: number;
  rank: number;
  seo_title: string;
  seo_keywords: string;
  seo_description: string;
  online_time: number;
  editor_id: number;
  editor_name: number;
  template_id: number;
  secret_id: number;
  hover_video: string;
  preview_m3u8_url: string;
  show_new_icon: boolean;
}

export interface HighlightFunction {
  name: string;
  description: string[];
}

export interface VideoCard {
  cover_image_url: string;
  video_url: string;
  highlight_function_list: HighlightFunction[];
}

export interface IIndustryApplication extends IDataBasic {
  tag_id: string;
  tag_name: string;
  title: string;
  description: string;
  icon_image_path: string;
  icon_image_url: string;
  cover_image_path: string;
  cover_image_url: string;
  // icon_image_path: string
  // icon_image_url: string
  video_path: string;
  video_url: string;
  online_status: number;
  editor_id: number;
  editor_name: number;
  rank: number;
  title_card_title: string;
  title_card_subtitle: string;
  title_card_description: string;
  title_card_cover_image_path: string;
  title_card_cover_image_url: string;
  seo_title: string;
  seo_keywords: string;
  seo_description: string;
  video_card: VideoCard[];
}

export interface IPageCard {
  id: string;
  title: string; // 标题
  sub_title: string; // 副标题
  type: number; // 类型
  description: string; // 引导文案
  cover_url: string; // 背景图url
  seo_title: string; // 搜索关键字 seo 用的 title
  seo_keywords: string; // 搜索关键字 seo 用的 keywords
  seo_description: string; // 搜索关键字 seo 用的 description
  update_time: number; // 更新时间
  cover_oss_path: string;
  create_time: string;
  hot_search_keywords: string[];
  editor_user_id: number | null;
  editor_name: string | null;
}

export enum PAGE_CARD_TYPE {
  PERSON_BEST = 0,
  HEL_CENTER = 1,
  ACADEMY = 2,
  NEWS = 4,
  CHARACTER = 5,
  TEMPLATE = 6,
  TUTORIAL = 7,
}

export interface TagGroup {
  english_name: string;
  chinese_name: string;
}

export interface TagItem {
  tag_id: number;
  tag_name: string;
  level: number;
  order_index: number;
  children: TagItem[];
  group: TagGroup[];
  pid: number | null;
  is_show: boolean;
  content: Record<string, any>;
  tag_group_id: number;
  message: string;
  detail_is_show: boolean;
  outer_id: string | null;
  show_of_application: boolean;
  show_hot: boolean;
  show_new: boolean;
}

export interface TagHeaderItem {
  tag_name: string;
  level: number;
}

export interface IGetTagsResponse {
  tag_header: TagHeaderItem[];
  tags: TagItem[];
}
